import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Vítej zpět.");
      navigate("/");
    } else {
      setError(res.error || "Přihlášení selhalo");
    }
  };

  return (
    <div className="min-h-screen bg-parchment flex flex-col">
      <div className="border-b border-stone">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12 h-16 flex items-center">
          <Link to="/" className="font-serif text-2xl text-navy">Discendo</Link>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          <p className="caption mb-6">Přihlášení</p>
          <h1 className="font-serif text-4xl text-ink mb-2">
            Pokračujme tam, <span className="font-serif-italic">kde jsi skončil(a)</span>.
          </h1>
          <p className="text-slate mb-10">Zadej svůj e-mail a heslo.</p>

          {error && <p role="alert" className="border border-red-300 text-red-800 p-4 mb-6">{error}</p>}
          <form onSubmit={onSubmit} className="space-y-6" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email" className="caption">E-mail</Label>
              <Input
                id="email" autoComplete="username"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
                className="bg-bone border-stone focus-visible:ring-navy"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="caption">Heslo</Label>
              <Input
                id="password" autoComplete="current-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
                className="bg-bone border-stone focus-visible:ring-navy"
              />
            </div>
            <Button
              type="submit"
              disabled={submitting}
              className="w-full bg-navy hover:bg-navy-dark text-parchment rounded-sm py-6"
              data-testid="login-submit-btn"
            >
              {submitting ? "Přihlašuji…" : "Přihlásit se"}
            </Button>
          </form>

          <p className="mt-10 text-sm text-slate">
            Ještě nemáš účet?{" "}
            <Link to="/registrace" className="text-navy underline underline-offset-4" data-testid="link-register">
              Vytvoř si jej.
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
